import { Component, Input } from '@angular/core';

@Component({
  selector: 'admin-app-calendar-icon',
  templateUrl: './calendar-icon.component.html',
  styleUrls: ['./calendar-icon.component.scss'],
  standalone: false
})
export class CalendarIconComponent {
  @Input() date: Date | string | number;
}
